import { Link } from "react-router-dom";
import React from "react";
import { useState } from "react";

const Pages = (props) => {
  const [modalIsOpen, setmodalIsOpen] = useState(false);

  const handleOpenModal = () => {
    setmodalIsOpen(true);
  }

  const handleCloseModal = () => {
    setmodalIsOpen(false);
  }

  return (
    //  <div className="numbers">{pages}</div>
    <>
      <div className="numbers">
        <Link to="/">
          <div className="number">(1)</div>
        </Link>
        <Link to="/ten-thirty/roof">
          <div className="number">(2)</div>
        </Link>
        <Link to="/ten-thirty/lightning">
          <div className="number">(3)</div>
        </Link>
        <Link to="/ten-thirty/summer">
          <div className="number">(4)</div>
        </Link>
        <Link to="/ten-thirty/noroom">
          <div className="number">(5)</div>
        </Link>
        <Link to="/ten-thirty/dawn">
          <div className="number">(6)</div>
        </Link>
        <Link to="/ten-thirty/pink">
          <div className="number">(7)</div>
        </Link>
        <div
          className="number"
          onClick={handleOpenModal}>
          (8)
        </div>
        <div
          className="number"
          onClick={handleOpenModal}
        >(9)</div>
        <div
          className="number"
          onClick={handleOpenModal}
        >(10)</div>
        <div
          className="number"
          onClick={handleOpenModal}
        >(11)</div>
        <div
          className="number"
          onClick={handleOpenModal}>
          (12)</div>
        <div 
          className="number"
          onClick={handleOpenModal}>
          (13)</div>
        <div 
          className="number"
          onClick={handleOpenModal}>
          (14)</div>
        <div 
          className="number"
          onClick={handleOpenModal}>
          (15)</div>
      </div>
      {modalIsOpen && (
        <div className="info-alert">
          <div className="info">
            <p>This will be updated soon..</p>
            <button onClick={handleCloseModal}>OKAY!</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Pages;
